import { Globe } from "lucide-react";
import { cn } from "@/lib/utils";
import { getCurrencyFlagEmoji } from "@/utils/currency-flag";

type Props = {
  code: string;
  className?: string;
  /** Slightly smaller flag in compact triggers */
  compact?: boolean;
  /** Hide flag/globe below md; currency code stays visible (e.g. booking bar on mobile). */
  hideFlagBelowMd?: boolean;
};

export function CurrencyCodeWithFlag({ code, className, compact, hideFlagBelowMd }: Props) {
  const emoji = getCurrencyFlagEmoji(code);
  const hideIcon = hideFlagBelowMd ? "hidden md:inline" : "";
  const hideGlobe = hideFlagBelowMd ? "hidden md:inline-block" : "";
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      {emoji ? (
        <span
          className={cn(
            "shrink-0 leading-none select-none",
            compact ? "text-[0.95rem]" : "text-[1.1rem]",
            hideIcon,
          )}
          aria-hidden
        >
          {emoji}
        </span>
      ) : (
        <Globe
          className={cn(
            "shrink-0 text-muted-foreground",
            compact ? "h-3 w-3" : "h-3.5 w-3.5",
            hideGlobe,
          )}
          aria-hidden
        />
      )}
      <span className="font-mono tabular-nums">{code}</span>
    </span>
  );
}
